import { defineComponent } from 'vue';
import Spinner from './Spinner.vue';
import $ from 'jquery';
import { numWithDots } from '~/lib/utils';
export default defineComponent({
    name: 'VariationStep',
    components: { Spinner },
    props: {
        product: {
            type: Object,
            required: true,
        },
        variation: {
            type: Object,
            default: null,
        },
    },
    emits: ['update:variation'],
    data() {
        return {
            loading: false,
            selectedVariation: null,
        };
    },
    computed: {
        width() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.width !== '') {
                return `W. ${this.selectedVariation.width}`;
            }
            return '';
        },
        depth() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.depth !== '') {
                return `D. ${this.selectedVariation.depth}`;
            }
            return '';
        },
        length() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.length !== '') {
                return `L. ${this.selectedVariation.length}`;
            }
            return '';
        },
    },
    watch: {
        selectedVariation() {
            this.$emit('update:variation', this.selectedVariation);
        },
    },
    mounted() {
        let maxHeight = $('.modal__content').height();
        if (maxHeight === undefined)
            return;
        $('.variations-step > div').css('max-height', maxHeight);
        $('.trade-product__carousel img').css('max-height', maxHeight);
        $('.trade-product__carousel').owlCarousel({
            items: 1,
            //loop: true,
            //autoHeight: true,
            nav: false,
            dots: true,
        });
    },
    methods: {
        // this fix the null option value bug
        /*selectVariation(v: Product | null | '') {
            this.selectedVariation = v === '' ? null : v;
        },*/
        formatPrice(x) {
            return numWithDots(x);
        }
    }
});
